import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlanChangePreviewState } from '../plan-change-preview/plan-change-preview.component';
import { ConfirmPlanDialogResult } from '../confirm-plan-dialog/confirm-plan-dialog.component';

@Component({
    selector: 'app-yearly-upgrade-dialog',
    templateUrl: './yearly-upgrade-dialog.component.html',
    styleUrls: ['./yearly-upgrade-dialog.component.css'],
    standalone: false
})
export class YearlyUpgradeDialogComponent {
  preview: PlanChangePreviewState;

  constructor(
    public dialogRef: MatDialogRef<YearlyUpgradeDialogComponent, ConfirmPlanDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.preview = { loading: this.hasPreview, loaded: false, prorationDate: null };
  }

  get hasPreview(): boolean {
    return !!this.data && !!this.data.planAlias && !!this.data.period;
  }

  onPreviewState(state: PlanChangePreviewState): void {
    this.preview = state;
  }

  onAccept(): void {
    this.dialogRef.close({ confirmed: true, prorationDate: this.preview.prorationDate });
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false, prorationDate: null });
  }
}
